import './note.css';

export default function Note({ children, className, ...props }) {
  return (
    <div className={`note${className ? ` ${className}` : ''}`} {...props}>{children}</div>
  );
}
